<template lang="pug">
  label.folders-select__row.flex-col(:style="{'margin-left':margin+'px'}")
      template(v-if="element.folder")
        span.folders-select__folder-accent(@click="selected('folder', element.folder)")
          | Папка: {{element.folder.name}}
          Checkbox(
            :value="element.folder.checked"
            :disabled="true"
          )
      template(v-if="element.groupArray && element.groupArray.length")
        label.folders-select__row.-course-(
          v-for="(group, groupIdx) in element.groupArray" :key="groupIdx+'group'+group.id"
          @click="selected('group', group)"
        )
          span.folders-select__text
            | {{group.name}}
            Checkbox(
              :value="group.checked"
              :disabled="true"
            )
      template(v-if="element.childrenFolders && element.childrenFolders.length >= 1")
        SelectItem(
          v-for="(item, idx) in element.childrenFolders"
          :data="item"
          v-model="newValue"
          @callBackData="callBack"
          :margin="margin+15"
          :key="data.folder.id + item.folder.id"
        )
</template>

<script>
import _ from 'lodash';

export default {
  name: 'SelectItem',
  props: {
    data: {},
    margin: {
      type: Number,
      default: 0
    },
    value: {},
    callBackData: {}
  },
  data() {
    return {
      element: {},
      text: [],
      item: {},
      newValue: []
    };
  },
  watch: {
    data() {
      this.element = _.cloneDeep(this.data);
      this.newValue = _.cloneDeep(this.value);
    },
    newValue() {
      this.$emit('input', this.newValue);
    }
  },
  mounted() {
    this.element = _.cloneDeep(this.data);
    if (this.value.length > 0) {
      this.newValue = _.cloneDeep(this.value);
    }
  },
  methods: {
    selected(type, elem) {
      elem.checked = !elem.checked;

      if (type === 'folder' && elem.checked) {
        const arrFolder = this.requrtionChecked().filter(
          el => !this.value.some(elem => elem.id === el.id)
        );
        this.newValue = [...this.value, ...arrFolder];
        this.element = _.cloneDeep(this.element);
      }

      if (!elem.checked) {
        this.element.folder.checked = false;
        if (type === 'group') {
          this.$emit('callBackData', false);
          this.newValue = [...this.value.filter(el => el.id != elem.id)];
        }
      }
      if (elem.checked && type == 'group') {
        this.newValue = [...this.value, elem];
      }
    },
    requrtionChecked(value = false) {
      const data = value || this.element;
      let valueData = [];
      if (data.groupArray && data.groupArray.length > 0) {
        if (!data.folder.checked) {
          data.folder = { ...data.folder, checked: true };
        }

        for (let i = 0; i < data.groupArray.length; i++) {
          data.groupArray[i] = { ...data.groupArray[i], checked: true };
          valueData.push(data.groupArray[i]);
        }
      }

      if (data.childrenFolders && data.childrenFolders.length > 0) {
        let valueDataChildren = [];
        for (let i = 0; data.childrenFolders.length > i; i++) {
          valueDataChildren = [
            ...valueDataChildren,
            ...this.requrtionChecked(data.childrenFolders[i])
          ];
        }
        valueData = [...valueData, ...valueDataChildren];
      }
      return valueData;
    },
    callBack() {
      this.element.folder.checked = false;
    },
    clearFolder() {
      this.element.folder.checked = this.value;
    }
  }
};
</script>
